import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../common/modules/admin/services/AdminService';
import { SessionService } from '../../common/modules/admin/services/SessionService';
import { UserService } from '../../common/modules/user/services/UserService';

@Component({
    selector: 'navigate-page',
    template: require('./NavigateComponent.html'),
    styles: [require('./NavigateComponent.sass')]
})
export class NavigateComponent implements OnInit {
    private sidebarStatus: boolean;
    private hostName: string;
    message: string;
    messageType: string;
    adminData: any;
    userData: any;
    myaisToken: any;
    role: any;
    protected devEnv: any = [
        'auth.eca.dev.nascorp.vn',
        'myais.eca.dev.nascorp.vn',
        'camp.eca.dev.nascorp.vn',
        'asa.eca.dev.nascorp.vn',
        'holiday.eca.dev.nascorp.vn',
        'bus.eca.dev.nascorp.vn',
        'conference.eca.dev.nascorp.vn',
        'acs.eca.dev.nascorp.vn',
        'kidzone.eca.dev.nascorp.vn'
    ];
    protected localEnv: any = [
        'auth.local.eca.dev.nascorp.vn',
        'myais.local.eca.dev.nascorp.vn',
        'kidzone.local.eca.dev.nascorp.vn'
    ];
    protected testEnv: any = [
        'auth.eca.test.nascorp.vn',
        'myais.eca.test.nascorp.vn',
        'camp.eca.test.nascorp.vn',
        'asa.eca.test.nascorp.vn',
        'holiday.eca.test.nascorp.vn',
        'bus.eca.test.nascorp.vn',
        'conference.eca.test.nascorp.vn',
        'acs.eca.dev.nascorp.vn'
    ];
    protected stagingEnv: any = [
        'auth.eca.uat.nascorp.vn',
        'services.eca.uat.nascorp.vn',
        'asa.eca.uat.nascorp.vn',
        'holidayschool.eca.uat.nascorp.vn',
        'bus.eca.uat.nascorp.vn',
        'outdooreducation.eca.uat.nascorp.vn',
        'reen.eca.uat.nascorp.vn',
        'acs.eca.uat.nascorp.vn',
        'pcbs.eca.uat.nascorp.vn'
    ];
    protected procEnv: any = [
        'auth.aisvietnam.com',
        'myais.vn',
        'outdooreducation.aisvietnam.com',
        'asa.aisvietnam.com',
        'holidayschool.aisvietnam.com',
        'bus.aisvietnam.com',
        'pcbs.aisvietnam.com',
        'acs.aisvietnam.com'
    ];

    constructor(
        protected router: Router,
        protected userService: UserService,
        protected sessionService: SessionService,
        protected adminService: AdminService
    ) {
        this.sidebarStatus = false;
    }

    ngOnInit() {
        this.getSession();
        this.sidebarStatus = false;
        this.hostName = window.location.hostname;
    }

    toAsa() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href = 'https://asa.aisvietnam.com/asa/admin/';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href =
                    'http://asa.eca.dev.nascorp.vn/asa/admin/';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://asa.eca.test.nascorp.vn/asa/admin/';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://asa.eca.uat.nascorp.vn/asa/admin/';
                break;
            default:
                window.location.href =
                    'http://asa.local.eca.dev.nascorp.vn/asa/admin/';
                break;
        }
    }

    toHoliday() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href =
                    'https://holidayschool.aisvietnam.com/holiday/admin/';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href =
                    'http://holiday.eca.dev.nascorp.vn/holiday/admin/';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://holiday.eca.test.nascorp.vn/holiday/admin/';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://holidayschool.eca.uat.nascorp.vn/holiday/admin/';
                break;
            default:
                window.location.href =
                    'http://holiday.local.eca.dev.nascorp.vn/holiday/admin/';
                break;
        }
    }

    toCamp() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href =
                    'https://outdooreducation.aisvietnam.com/camp/admin/';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href =
                    'http://camp.eca.dev.nascorp.vn/camp/admin/';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://camp.eca.test.nascorp.vn/camp/admin/';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://outdooreducation.eca.uat.nascorp.vn/camp/admin/';
                break;
            default:
                window.location.href =
                    'http://camp.local.eca.dev.nascorp.vn/camp/admin';
                break;
        }
    }

    toBus() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href = 'https://bus.aisvietnam.com/bus/admin/';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href =
                    'http://bus.eca.dev.nascorp.vn/bus/admin/';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://bus.eca.test.nascorp.vn/bus/admin/';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://bus.eca.uat.nascorp.vn/bus/admin/';
                break;
            default:
                window.location.href = 'http://bus.local.eca.dev.nascorp.vn/';
                break;
        }
    }

    toConferenceBooking() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href =
                    'https://pcbs.aisvietnam.com/conference/admin/';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href =
                    'http://conference.eca.dev.nascorp.vn/conference/admin/';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://conference.eca.test.nascorp.vn/conference/admin/';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://pcbs.eca.uat.nascorp.vn/conference/admin/';
                break;
            default:
                window.location.href =
                    'http://conference.local.eca.dev.nascorp.vn/conference/admin/';
                break;
        }
    }

    toAccessControl() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href = 'https://acs.aisvietnam.com/';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href = 'http://acs.eca.dev.nascorp.vn/';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://acs.eca.test.nascorp.vn/';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://acs.eca.uat.nascorp.vn/';
                break;
            default:
                window.location.href =
                    'http://acs.local.eca.dev.nascorp.vn/';
                break;
        }
    }

    private getSession(): void {
        this.sessionService.getSession().subscribe(
            user => {
                this.userData = user;
                // this.adminData = this.adminService.getAdminSessionData();
                // this.role = this.adminData.role
                this.role = this.userData.role;
                console.log(this.role);
            },
            error => {
                //TO DO: Handle any error if needed in the furture
                this.message = '';
                this.messageType = 'alert';
            }
        );
    }

    toEdPay() {
        window.location.href = '/api/sso/edpay/token';
    }

    toMyAis() {
        switch (this.hostName) {
            case "auth.aisvietnam.com":
                window.location.href =
                "https://auth.aisvietnam.com/calendars";
                break;
            case "auth.eca.dev.nascorp.vn":
                window.location.href =
                "http://auth.eca.dev.nascorp.vn/calendars";
                break;
            case "auth.eca.test.nascorp.vn":
                window.location.href =
                "http://auth.eca.test.nascorp.vn/calendars";
                break;
            case "auth.eca.uat.nascorp.vn":
                window.location.href =
                "http://auth.eca.uat.nascorp.vn/calendars";
                break;
            default:
                window.location.href =
                "http://auth.local.eca.dev.nascorp.vn/calendars";
                break;
        }
        // this.myAisToken();
        // window.open('http://myais.vn', '_blank')
    }

    // Convert string SHA1
    SHA1(msg: any) {
        function rotate_left(n: any, s: any) {
            var t4 = (n << s) | (n >>> (32 - s));
            return t4;
        }
        function lsb_hex(val: any) {
            var str = '';
            var i;
            var vh;
            var vl;
            for (i = 0; i <= 6; i += 2) {
                vh = (val >>> (i * 4 + 4)) & 0x0f;
                vl = (val >>> (i * 4)) & 0x0f;
                str += vh.toString(16) + vl.toString(16);
            }
            return str;
        }
        function cvt_hex(val: any) {
            var str = '';
            var i;
            var v;
            for (i = 7; i >= 0; i--) {
                v = (val >>> (i * 4)) & 0x0f;
                str += v.toString(16);
            }
            return str;
        }
        function Utf8Encode(string: any) {
            string = string.replace(/\r\n/g, '\n');
            var utftext = '';
            for (var n = 0; n < string.length; n++) {
                var c = string.charCodeAt(n);
                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if (c > 127 && c < 2048) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
            }
            return utftext;
        }
        var blockstart;
        var i, j;
        var W = new Array(80);
        var H0 = 0x67452301;
        var H1 = 0xefcdab89;
        var H2 = 0x98badcfe;
        var H3 = 0x10325476;
        var H4 = 0xc3d2e1f0;
        var A, B, C, D, E;
        var temp;
        msg = Utf8Encode(msg);
        var msg_len = msg.length;
        var word_array = new Array();
        for (i = 0; i < msg_len - 3; i += 4) {
            j =
                (msg.charCodeAt(i) << 24) |
                (msg.charCodeAt(i + 1) << 16) |
                (msg.charCodeAt(i + 2) << 8) |
                msg.charCodeAt(i + 3);
            word_array.push(j);
        }
        switch (msg_len % 4) {
            case 0:
                i = 0x080000000;
                break;
            case 1:
                i = (msg.charCodeAt(msg_len - 1) << 24) | 0x0800000;
                break;
            case 2:
                i =
                    (msg.charCodeAt(msg_len - 2) << 24) |
                    (msg.charCodeAt(msg_len - 1) << 16) |
                    0x08000;
                break;
            case 3:
                i =
                    (msg.charCodeAt(msg_len - 3) << 24) |
                    (msg.charCodeAt(msg_len - 2) << 16) |
                    (msg.charCodeAt(msg_len - 1) << 8) |
                    0x80;
                break;
        }
        word_array.push(i);
        while (word_array.length % 16 != 14) word_array.push(0);
        word_array.push(msg_len >>> 29);
        word_array.push((msg_len << 3) & 0x0ffffffff);
        for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
            for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i];
            for (i = 16; i <= 79; i++)
                W[i] = rotate_left(
                    W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16],
                    1
                );
            A = H0;
            B = H1;
            C = H2;
            D = H3;
            E = H4;
            for (i = 0; i <= 19; i++) {
                temp =
                    (rotate_left(A, 5) +
                        ((B & C) | (~B & D)) +
                        E +
                        W[i] +
                        0x5a827999) &
                    0x0ffffffff;
                E = D;
                D = C;
                C = rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 20; i <= 39; i++) {
                temp =
                    (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) &
                    0x0ffffffff;
                E = D;
                D = C;
                C = rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 40; i <= 59; i++) {
                temp =
                    (rotate_left(A, 5) +
                        ((B & C) | (B & D) | (C & D)) +
                        E +
                        W[i] +
                        0x8f1bbcdc) &
                    0x0ffffffff;
                E = D;
                D = C;
                C = rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 60; i <= 79; i++) {
                temp =
                    (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) &
                    0x0ffffffff;
                E = D;
                D = C;
                C = rotate_left(B, 30);
                B = A;
                A = temp;
            }
            H0 = (H0 + A) & 0x0ffffffff;
            H1 = (H1 + B) & 0x0ffffffff;
            H2 = (H2 + C) & 0x0ffffffff;
            H3 = (H3 + D) & 0x0ffffffff;
            H4 = (H4 + E) & 0x0ffffffff;
        }
        temp =
            cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);

        return temp.toLowerCase();
    }

    myAisToken() {
        if (this.userData) {
            let randomChar = Math.random()
                .toString(36)
                .substr(2, 4);
            let firstConvert = this.SHA1('a#BAC@21' + randomChar);
            this.myaisToken = randomChar.concat(firstConvert);
            if (this.devEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href = `http://myais.eca.dev.nascorp.vn/loginservice/${
                    this.myaisToken
                }`);
            } else if (this.testEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href = `http://myais.eca.test.nascorp.vn/loginservice/${
                    this.myaisToken
                }`);
            } else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href = `http://myais.eca.uat.nascorp.vn/loginservice/${
                    this.myaisToken
                }`);
            } else if (this.procEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href = `http://myais.vn/loginservice/${
                    this.myaisToken
                }`);
            } else if (this.localEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href = `http://myais.eca.dev.nascorp.vn/loginservice/${
                    this.myaisToken
                }`);
            }
        } else {
            // Redirect to desired URL
            if (this.devEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href =
                    'http://services.eca.dev.nascorp.vn');
            } else if (this.testEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href =
                    'http://services.eca.test.nascorp.vn');
            } else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href =
                    'http://services.eca.uat.nascorp.vn');
            } else if (this.procEnv.indexOf(this.hostName) !== -1) {
                return (window.location.href =
                    'https://services.aisvietnam.com');
            } else {
                return (window.location.href =
                    'http://services.local.eca.dev.nascorp.vn');
            }
        }
    }

    // toHandbook() {
    //     window.open(
    //         '',
    //         '_blank'
    //     );
    // }

    toReen() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href =
                    'https://reen.aisvietnam.com/reen/admin/';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href =
                    'http://reen.eca.dev.nascorp.vn/reen/admin/';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://reen.eca.test.nascorp.vn/reen/admin/';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://reen.eca.uat.nascorp.vn/reen/admin/';
                break;
            default:
                window.location.href =
                    'http://reen.local.eca.dev.nascorp.vn/reen/admin/';
                break;
        }
    }
    toEnrolment() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href =
                    'https://apply.aisvietnam.com/admin/';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href =
                    'http://enrolment.eca.dev.nascorp.vn/admin/';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://enrolment.eca.test.nascorp.vn/admin/';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://apply.eca.uat.nascorp.vn/admin/';
                break;
            default:
                window.location.href =
                    'http://enrolment.local.eca.dev.nascorp.vn/admin/';
                break;
        }
    }
    toKidZone() {
        switch (this.hostName) {
            case 'auth.aisvietnam.com':
                window.location.href =
                    'https://kidzone.aisvietnam.com/admin';
                break;
            case 'auth.eca.dev.nascorp.vn':
                window.location.href =
                    'http://kidzone.eca.dev.nascorp.vn/admin';
                break;
            case 'auth.eca.test.nascorp.vn':
                window.location.href =
                    'http://kidzone.eca.test.nascorp.vn/admin';
                break;
            case 'auth.eca.uat.nascorp.vn':
                window.location.href =
                    'http://kidzone.uat.nascorp.vn/admin';
                break;
            default:
                window.location.href =
                    'http://kidzone.local.eca.dev.nascorp.vn/admin';
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/auth/navigate-page/NavigateComponent.ts